var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-edit"},[_c('edit',{attrs:{"fs":_vm.articleEditFields,"id":_vm.id,"api":"articles","title":"Edit Article"},on:{"changed":_vm.changed,"saved":_vm.saved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }